export enum SceneKeys {
    PRELOADER = "PRELOADER",
    MENU = "MENU",
    MATTER_SHAPE_EDITOR = "MATTER_SHAPE_EDITOR",
    GAME = "GAME",
    UI = "UI"
}